import formatOpeningTimesPayload from './formatOpeningTimesPayload';
export default formatOpeningTimesPayload;
